import {
  isNavigationMenuNestedGroup,
  type NavigationMenuGroupItem,
  type NavigationMenuItem,
} from "@/components/header/navigationQuery.types";

export const findNavigationGroupByKey = (
  items: NavigationMenuItem[] | null | undefined,
  key: string,
): NavigationMenuGroupItem | undefined =>
  items?.find(
    (item): item is NavigationMenuGroupItem =>
      item._type === "navigationGroup" && item._key === key,
  );

export const getFeaturedItems = (menu?: NavigationMenuGroupItem) =>
  menu?.featuredItems;

export type MobileMenuLinkItem = {
  _key?: string;
  label?: string | null;
  link: {
    url?: string | null;
    queryString?: string | null;
    openInNewTab?: boolean | null;
  };
};

export const toMobileMenuLink = (item: {
  _key?: string;
  _type?: string;
  label?: string | null;
  link?: MobileMenuLinkItem["link"] | null;
}): MobileMenuLinkItem | null => {
  if (item._type === "navigationGroup" || !item.link?.url) return null;
  return { _key: item._key, label: item.label, link: item.link };
};

export const hasNestedColumns = (menu: NavigationMenuGroupItem) =>
  Boolean(menu.items?.some(isNavigationMenuNestedGroup));
